import React from "react";
import { useEstadoAlquiler } from "../hooks/useEstadoAlquiler";

// Badge reutilizable para tablas de alquiler (por defecto renderiza un <td>).
const EstadoAlquilerComponent = ({
  estado,
  fechaHoraDevolucionEsperada,
  as: Tag = "td",
  styleGroup = "",
}) => {
  const { calcularEstadoAlquiler } = useEstadoAlquiler();

  const { text, className } = calcularEstadoAlquiler({
    estado,
    fechaHoraDevolucionEsperada,
  });

  return (
    <Tag className={`text-center ${className} ${styleGroup}`}>{text}</Tag>
  );
};

export default EstadoAlquilerComponent;
